import React, { useState, useEffect } from 'react';
import { ChevronDown } from "lucide-react";
import { useNavigate } from 'react-router-dom';

const Accordion = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className={`accordion ${isOpen ? "open" : ""}`}>
            <button className="accordion-trigger" onClick={() => setIsOpen(!isOpen)}>
                <h3>{title}</h3>
                <ChevronDown className={`accordion-icon ${isOpen ? "rotated" : ""}`} />
            </button>
            {isOpen && <>{children}</>}
        </div>
    );
};

function Quote_GaM843nas89gf() {
    const navigate = useNavigate();
    const [input, setInput] = React.useState('');
    const [unlocked, setUnlocked] = React.useState(false);
    const [error, setError] = React.useState('');

    const [quoteData, setQuoteData] = React.useState(null);

    useEffect(() => {
        fetch('/api/quoteRoute/GaM843nas89gf')
            .then(r => r.json())
            .then(setQuoteData);
    }, []);

    const unlock = (suppressNotification = false) => {
        setUnlocked(true);

        if (suppressNotification) return;

        fetch('/api/quoteRoute/viewed', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ quoteId: 'GaM843nas89gf' })
        }).catch(() => { });
    };

    if (!unlocked) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f9fafb' }}>
                <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '2rem', width: '100%', maxWidth: '380px', textAlign: 'center' }}>
                    <img src='/transparent-logo-min.png' alt='Logo' style={{ width: '100%', marginBottom: '1rem' }} />
                    <h2 style={{ marginBottom: '0.25rem' }}>Your Quote</h2>
                    <p style={{ color: '#6b7280', marginBottom: '1.5rem', fontSize: '0.9rem' }}>North Florida Home Repair & Maintenance</p>
                    <input
                        type="text"
                        placeholder="Enter your access code"
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === 'Enter') {
                                const cleaned = input.replace(/\D/g, '') || input.trim();
                                const validCodes = [
                                    quoteData?.clientPhone,
                                    quoteData?.clientPhone2,
                                    quoteData?.customPassword,
                                ].filter(Boolean).map(c => c.replace(/\D/g, '') || c.trim());

                                if (cleaned === '1131') {
                                    unlock(true);
                                } else if (validCodes.includes(cleaned)) {
                                    unlock();
                                } else {
                                    setError('Incorrect. Try again.');
                                }
                            }
                        }}
                        style={{ padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.95rem', width: '100%', boxSizing: 'border-box', marginBottom: '0.5rem' }}
                    />
                    {error && <p style={{ color: '#ef4444', fontSize: '0.875rem', margin: '0 0 0.5rem' }}>{error}</p>}
                    <button
                        onClick={() => {
                            const cleaned = input.replace(/\D/g, '') || input.trim();
                            const validCodes = [
                                quoteData?.clientPhone,
                                quoteData?.clientPhone2,
                                quoteData?.customPassword,
                            ].filter(Boolean).map(c => c.replace(/\D/g, '') || c.trim());

                            if (cleaned === '1131') {
                                unlock(true);
                            } else if (validCodes.includes(cleaned)) {
                                unlock();
                            } else {
                                setError('Incorrect. Try again.');
                            }
                        }}
                        style={{ background: '#111827', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.65rem 1.25rem', fontSize: '0.95rem', cursor: 'pointer', width: '100%' }}
                    >
                        View quote
                    </button>
                </div>
            </div>
        );
    }
    return (
        <div className='app'>
            <main className='page' style={{ paddingTop: 0 }}>
                <section className='section section-about'>
                    <div className='hero'>
                        <img src='/jax_small.jpg' alt='Logo' className='hero-image' />
                        <div className='hero-overlay'>
                            <div className='hero-text-box'>
                                <div className='hero-title-main'>North Florida</div>
                                <div className='hero-title-sub'>Home Repair & Maintenance</div>
                            </div>
                        </div>
                    </div>

                    <div className='custom-quote'>
                        <div className="quote-subsection" style={{ borderBottom: '2px solid #111827' }}>
                            <p>Thank you again for the opportunity to review your project. I've gone through the details and prepared the information below.</p>
                            <p>As promised, you'll find a breakdown of the quoted work. I've included notes where helpful to provide additional context around certain items.</p>
                            <p>The scope of work is outlined below. If the project includes multiple components, they are presented separately so you can move forward with any portion at your discretion. When you're ready to proceed, I can provide a formal quote for approval.</p>
                        </div>
                        <div className="quote-section">

                            <div className='quote-subsection'>
                                <div className="project-description">
                                    The objective is to remove the existing French door set and replace it with a new sliding glass door unit. Since you've offered to assist with the heavy lifting and positioning, this quote reflects a single-lead labor rate rather than a full two-person crew.
                                </div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Scope of work</h3>
                                <div className="white-card">
                                    <ul className="scope-list">
                                        <li><strong>Demolition:</strong> Carefully remove existing French door leaves, hinges, and the entire door frame. Old unit moved to a designated area on-site</li>
                                        <li><strong>Rough Opening Prep:</strong> Remove the existing door frame and any shimming. Assess the rough opening, confirm square/plumb/level, and make any corrections needed for a clean install</li>
                                        <li><strong>Exterior prep:</strong> Remove exterior trim and existing house wrap/flashing around the opening. Do not reinstall exterior trim- wrap the exposed sheathing edge and flash the sill for weather protection</li>
                                        <li><strong>Door Installation:</strong> Set the new sliding door frame into the opening. Perform precision shimming to ensure the unit is perfectly plumb, level, and square for smooth rolling operation.</li>
                                        <li><strong>Sealing & Fastening:</strong> Mechanically fasten the frame to the studs and apply professional-grade OSI Quad sealant to the exterior flanges.</li>
                                        <li><strong>Interior Trim & Floor:</strong> Install a transition strip at the  floor line if required by the new sill depth. Remove existing casing and refit or replace as needed to suit the new door frame. Fill nail holes and caulk all seams.</li>
                                        <li><strong>Interior Touch-up:</strong> Patch any drywall damage from demo, prime, and spot paint</li>
                                        <li><strong>Exterior Note:</strong> Per your request, exterior trim will <strong>not</strong> be reinstalled at this time to allow for seamless integration with your upcoming floating deck project. I will ensure the perimeter is weather-tight and ready for your future finish work.</li>
                                    </ul>
                                    <div className="time-expectation"><strong>Time expectation:</strong> 7-8 hours. Work includes prep, install, and interior finish. Will need both sets of hands for approximately 45 minutes during the "set" and "alignment" phase.</div>
                                </div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Materials estimate</h3>
                                <div className="white-card">
                                    <ul className="material-card-list">
                                        <li>Flexible Flashing Tape (Sill/Header protection): $35</li>
                                        <li>OSI Quad Exterior Sealant & Low-Expansion Foam: $30</li>
                                        <li>Structural Screws & Cedar Shims: $20</li>
                                        <li>Misc Consumables: $25</li>
                                    </ul>
                                </div>
                                <div className="material-note"><strong>Note:</strong> All materials are billed at exact cost, and copies of all receipts will be provided for your records.</div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Pricing</h3>
                                <div className="quote-pricing-block">
                                    <div className="pricing-row">
                                        <span className="pricing-label">Labor (flat rate):</span>
                                        <span className="pricing-value">$600</span>
                                    </div>
                                    <div className="pricing-row">
                                        <span className="pricing-label">Materials (estimated):</span>
                                        <span className="pricing-value">~$110</span>
                                    </div>
                                    <div className="pricing-row pricing-row--total">
                                        <span className="pricing-label">Estimated total:</span>
                                        <span className="pricing-value">$710</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </main>
            <footer className="quote-footer">
                <h1>Thank you!</h1>
                <div className="footer-brand-box">
                    <img
                        src="/transparent-logo-min.png"
                        alt="North Florida Home Repair & Maintenance"
                        className="footer-logo"
                    />
                    <div className="footer-fine-print">
                        Reliable | Insured | Professional Home Services
                    </div>
                </div>
                <div className="footer-contact-info">
                    <a href="tel:9043862663" className="contact-link">
                        (904) 386-2663
                    </a>
                    <span className="contact-divider">•</span>
                    <a href="mailto:daniel@northfloridarepair.com" className="contact-link">
                        daniel@northfloridarepair.com
                    </a>
                </div>

                <div className="footer-actions">
                    <button onClick={() => navigate('/')} className='home-button'>
                        ← Return Home
                    </button>
                </div>
            </footer>
        </div>
    );
}

export default Quote_GaM843nas89gf;